<script>
  import { onMount, tick } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { authStore } from '../authStore';
  import { getApiUrl } from '../api';
  import { authFetch } from '../authService';
  import { getStripeUrl } from '../api';

  export let id; // Membership ID from the URL
  
  let stripe = null;
  let elements = null;
  
  // State for the initial setup
  let isSetupLoading = true;
  let setupMessage = "Initializing payment...";

  // --- THE FIX: Separate state for submission ---
  let isSubmitting = false;
  let submitMessage = "";

  const STRIPE_KEY = getStripeUrl();
  
  onMount(async () => {
    stripe = Stripe(STRIPE_KEY);
    try {
        setupMessage = "Contacting our server...";
        const response = await authFetch(getApiUrl('/create-payment-intent'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ membershipId: id }),
        });
        if (!response.ok) throw new Error("Failed to create payment intent on the server.");
        const { clientSecret } = await response.json();
        if (!clientSecret) throw new Error("Did not receive a client secret from the server.");
        
        isSetupLoading = false;
        setupMessage = "";
        await tick();
        
        elements = stripe.elements({ clientSecret });
        const paymentElement = elements.create('payment');
        paymentElement.mount('#payment-element');
    } catch (error) {
        console.error("Payment setup error:", error);
        setupMessage = `Error: ${error.message}`;
        isSetupLoading = false;
    }
  });

  async function handleSubmit() {
    isSubmitting = true;
    submitMessage = "Processing payment...";
    
    const { error: stripeError, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: window.location.href },
      redirect: 'if_required',
    });

    console.log("Stripe confirmPayment response:", { stripeError, paymentIntent });

    if (stripeError) {
      submitMessage = stripeError.message;
      isSubmitting = false;
      return;
    }

    if (paymentIntent.status === 'succeeded') {
      submitMessage = "Payment successful! Activating subscription...";
      const userId = $authStore.user.idTokenClaims.oid;
      const displayName = $authStore.user.name; // Get display name from auth store

      try {
        console.log("Attempting to create subscription with payload:", { userId, membershipClassId: id, displayName });
        // const subResponse = await fetch(getApiUrl('/subscriptions'), {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ userId, membershipClassId: id, displayName })
        // });
        const payload = {
            userId,
            displayName,
            membershipClassId: id,
            paidAmount: paymentIntent.amount / 100, // Convert from cents
            paidCurrency: paymentIntent.currency.toUpperCase(),
            paymentIntentId: paymentIntent.id
        };

        const subResponse = await authFetch(getApiUrl('/subscriptions'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if(!subResponse.ok) {
            const errData = await subResponse.json();
            throw new Error(errData.error || "Server responded with an error.");
        }
        submitMessage = "Subscription activated! Redirecting...";
        setTimeout(() => navigate('/profile'), 2000); // Redirect to profile to see the new subscription
      } catch (e) {
         console.error("Failed to create subscription record:", e);
         submitMessage = `Payment succeeded, but failed to activate subscription. Error: ${e.message}`;
      }

      

    } else {
        submitMessage = `Payment not successful. Status: ${paymentIntent.status}`;
    }
    isSubmitting = false;
  }
</script>

<div class="payment-container">
  <h2>Complete Your Subscription</h2>

  <!-- This block now only handles the initial setup -->
  {#if isSetupLoading || setupMessage}
    <div id="payment-message">{setupMessage}</div>
  {:else}
    <!-- Once setup is done, the form stays on the page -->
    <form id="payment-form" on:submit|preventDefault={handleSubmit}>
      <div id="payment-element"></div>
      
      <button disabled={isSubmitting} id="submit">
        {#if isSubmitting}Processing...{:else}Pay now{/if}
      </button>
      
      <!-- Display submission messages here -->
      {#if submitMessage}
        <div id="payment-message">{submitMessage}</div>
      {/if}
    </form>
  {/if}
</div>

<style>
  .payment-container { max-width: 500px; margin: 2rem auto; padding: 2rem; border: 1px solid #ddd; border-radius: 8px; box-shadow: 0 4px 6px rgba(0,0,0,0.05); }
  #payment-element { margin-bottom: 24px; }
  button {
    background: #5469d4;
    color: #ffffff;
    border-radius: 4px;
    border: 0;
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: block;
    transition: all 0.2s ease;
    width: 100%;
  }
  button:hover { filter: contrast(115%); }
  button:disabled { opacity: 0.5; cursor: default; }
  #payment-message {
    color: rgb(105, 115, 134);
    font-size: 16px;
    line-height: 20px;
    padding-top: 12px;
    text-align: center;
  }
</style>
